<template>
  <div>
    <BaseButton primary @click="createContact"> {{ $t('accountContacts.newContact') }} </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    createContact() {
      this.$modal.show({
        component: () => import('./CreateContactDialog.vue'),
        props: {
          accountId: this.accountId,
        },
        on: {
          created: (contactId) => {
            this.$emit('created', contactId);
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
